import { Box, Chip, FormLabel, Stack } from '@mui/material';
import { produce } from 'immer';
import _ from 'lodash';
import { useRef } from 'react';
import { PrimaryButton } from '../style/ButtonStyle';
import { AttachmentArea } from '../style/CommonStyle';

export const FileInput = ({ form }: any) => {
  const fileInputRef = useRef<any>();

  function onAdd(e) {
    const file = e.target.files[0];

    if (!file) return;

    const attachments = form.watch('attachmentDetails') || [];
    const newAttachment = produce(attachments, draft => {
      draft.push(file);
    });

    form.setValue('attachmentDetails', newAttachment);
  }

  return (
    <>
      <FormLabel>파일 첨부</FormLabel>
      <AttachmentArea direction={{ xs: 'column', md: 'row' }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ flexWrap: 'wrap', rowGap: '8px' }}
        >
          <input
            style={{ display: 'none' }}
            type="file"
            ref={fileInputRef}
            onChange={onAdd}
            multiple={false}
          />
          {_.map(form.watch('attachmentDetails') || [], (a, i) => {
            return (
              <Chip
                key={i}
                label={a?.name}
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '186px',
                  marginTop: '8px !important',
                }}
                onDelete={() => {
                  const attachments = form.watch('attachmentDetails') || [];
                  const deletedAttachments =
                    form.watch('deletedAttachments') || [];

                  const newDeletedAttachments = [
                    ...deletedAttachments,
                    a.attachmentId,
                  ];
                  form.setValue('deletedAttachments', newDeletedAttachments);

                  const newAttachment = produce(attachments, draft => {
                    draft.splice(i, 1);
                  });
                  form.setValue('attachmentDetails', newAttachment);
                }}
              />
            );
          })}
        </Stack>
        <Stack
          sx={{ maxHeight: '52px' }}
          alignItems={{ xs: 'flex-end', md: 'auto' }}
        >
          {_.isEmpty(form.watch('attachmentDetails')) ? <Box /> : <></>}
          <PrimaryButton
            sx={{ width: '120px', maxHeight: '48px', mt: 0.5 }}
            onClick={() => {
              fileInputRef.current.click();
            }}
          >
            파일 첨부
          </PrimaryButton>
        </Stack>
      </AttachmentArea>
    </>
  );
};
